import styled from "styled-components"
import { BookingInformationFormWrapper } from "../bookingInformationForm/styles"

export const ReviewFormWrapper = styled(BookingInformationFormWrapper)`
	.containerItem {
		p {
			&:nth-child(1) {
				color: #130080;
			}
			&:nth-child(2) {
				margin: 0;
				color: #8e98a1;
			}
			color: #0f172a;
			span {
				color: #5b3fff;
			}
		}
	}
`
